import {
  QueryModel,
  UseQueryParamsProps,
  UseQueryParamsReturn,
  useQueryParams,
} from '@domonda/query-params';
import { GetValidatableInvoiceContainersParams } from 'lib/api/invoiceContainers';

export type DocumentsOverviewQueryParams = GetValidatableInvoiceContainersParams;

export const documentsOverviewModel: QueryModel<DocumentsOverviewQueryParams> = {
  fullTextQuery: {
    type: 'string',
    defaultValue: null,
  },
  documentState: {
    type: 'string',
    defaultValue: 'needForAction',
    validate: (value) => {
      switch (value) {
        case 'error':
        case 'needForAction':
        case 'autoprocessed':
        case 'New,Autoprocessed,NeedForAction,Validated,Released,Downloaded,Error,Deleted,Confirmed':
          return true;
      }
      return false;
    },
  },
  orderBy: {
    type: 'string',
    defaultValue: null,
  },
  orderDescending: {
    type: 'boolean',
    defaultValue: null,
  },
  PageNumber: {
    type: 'number',
    defaultValue: 1,
  },
  PageSize: {
    type: 'number',
    defaultValue: 25,
  },
  invoiceDetailsToQuery: {
    type: 'string',
    defaultValue: null,
  },
  invoiceDetailQuery: {
    type: 'string',
    defaultValue: null,
  },
};

export function useDocumentsOverviewQueryParams(
  props?: UseQueryParamsProps,
): UseQueryParamsReturn<DocumentsOverviewQueryParams> {
  const [params, setParams] = useQueryParams(documentsOverviewModel, props);
  return [params, setParams];
}
